import { SVGSprite } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";
import { classNameGenerator, clsx } from "@/utils";
import styles from "./TimerSection.module.scss"
import dynamic from "next/dynamic";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { useCallback, useEffect, useState } from "react";
import * as actions from "@/redux/BootCampReducer";
import OfferCountdown from "./TimeCounter/index"


const TimerSection = ({
    icon = "icon-green-star",
    ctaIconColor = "white"
}) => {
    const cls = classNameGenerator(styles)
    const dispatch = useAppDispatch();
    const [isPageLoaded,setIsPageLoaded] = useState(true)    
    const { isLoading: dataLoading, data } = useAppSelector((state) => state.bootCamp);

    const { currencySymbol, price } = data?.packData || {};
    const { offerEndDate, slots=0, discount, date } = data?.heroSection?.offerSection
    
    useEffect(() => {
        setIsPageLoaded(dataLoading)
    },[dataLoading])
    
    const setShowBookSlotModal = useCallback(
        (value: any) => {
            dispatch(actions.setShowBookSlotModal(value));
        },
        [dispatch]
    );

    return (
        <div className={cls("timerContainer")}>
            <div className={cls("timerWrapper")}>
                <div className={cls("leftSection")}>
                    <Typography
                        variant="heading4"
                        className={cls("title")}
                        dangerouslySetInnerHTML={{ __html: `Next course starts on: ${date}` }}
                    />
                    <div className={cls("bottomSection")}>
                        <span className={cls("time")}>
                            <OfferCountdown
                                endDate={offerEndDate}
                                className={cls("floatingBannerTimer")}
                            />
                        </span>
                        <div className={cls("slots")}>
                            <SVGSprite
                                className={cls("icon")}
                                icon={"icon-fire"}
                            />
                            <span
                                className={cls("count")}
                            >
                                {slots}
                            </span>
                            <Typography
                                variant="heading4"
                                className={cls("left")}
                                dangerouslySetInnerHTML={{ __html: "Slots left" }}
                            />
                        </div>
                    </div>
                </div>
                <div className={cls("rightSection")}>
                    <div className={cls("topSection")}>
                        <SVGSprite
                            className={cls("icon")}
                            icon={icon}
                        />
                        <span className={cls("discount")}>{discount}</span>
                        <Typography
                            variant="heading4"
                            className={cls("text")}
                            dangerouslySetInnerHTML={{ __html: "Early bird offer" }}
                        />
                    </div>
                    <button
                        type="button"
                        className={cls("heroCtaButton")}
                        onClick={() =>
                            setShowBookSlotModal({
                                packageData: data?.packData,
                                showSubtitle: true,
                            })
                        }
                        disabled={isPageLoaded}
                    >
                        <span
                            className={cls("heroCtaButtonText")}
                            dangerouslySetInnerHTML={{ __html: `Enroll now for ${currencySymbol} ${price}` }}
                        />
                        <span className={clsx(cls("icon"), cls(ctaIconColor))}>
                            {arrowIcon}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TimerSection;

const arrowIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            d="M6.5 13L10.5 9L6.5 5"
            stroke="#ffffff"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);